let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Lkvk")).then(() => parcelRequire('3okML'));